import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type FileType = 'img' | 'pdf' | 'doc' | 'ppt' | 'xls' | 'unknown';

@Component({
	selector: 'app-file-icon',
	imports: [CommonModule],
	templateUrl: './file-icon.component.html',
	styleUrl: './file-icon.component.scss',
})
export class FileIconComponent {
	@Input() fileType: FileType = 'unknown';
	@Input() fileName?: string;

	/**
	 * Detects the file type based on the file name's extension
	 */
	ngOnInit() {
		if (this.fileName && this.fileType === 'unknown') {
			this.fileType = this.detectFileType(this.fileName);
		}
	}

	/**
	 * Detects the file type based on the extension
	 */
	private detectFileType(fileName: string): FileType {
		const extension = fileName.split('.').pop()?.toLowerCase();

		switch (extension) {
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
			case 'webp':
			case 'svg':
			case 'bmp':
				return 'img';

			case 'pdf':
				return 'pdf';

			case 'doc':
			case 'docx':
				return 'doc';

			case 'ppt':
			case 'pptx':
				return 'ppt';

			case 'xls':
			case 'xlsx':
			case 'csv':
				return 'xls';

			default:
				return 'unknown';
		}
	}

	/**
	 * Returns the extension to display in the badge
	 */
	getFileExtension(): string {
		if (this.fileName) {
			const ext = this.fileName.split('.').pop()?.toUpperCase();
			return ext || 'FILE';
		}

		switch (this.fileType) {
			case 'img':
				return 'IMG';
			case 'pdf':
				return 'PDF';
			case 'doc':
				return 'DOC';
			case 'ppt':
				return 'PPT';
			case 'xls':
				return 'XLS';
			default:
				return 'FILE';
		}
	}

	/**
	 * Returns the path of the SVG icon matching the file type
	 */
	getIconPath(): string {
		switch (this.fileType) {
			case 'img':
				return 'assets/layout/files/IMG.svg';
			case 'pdf':
				return 'assets/layout/files/PDF.svg';
			case 'doc':
				return 'assets/layout/files/DOC.svg';
			case 'ppt':
				return 'assets/layout/files/PPT.svg';
			case 'xls':
				return 'assets/layout/files/XLS.svg';
			default:
				// Use PDF as the default icon for unknown files
				return 'assets/layout/files/PDF.svg';
		}
	}
}
